export default __webpack_public_path__ + "static/media/cuciReloadFaq3.141cfba8.png";